import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import { getAdmins } from './firestoreService';

let authorizedEmails = [];
let lastFetchTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Fetch authorized emails from Firestore
const fetchAuthorizedEmails = async () => {
  const now = Date.now();

  // Use cached data if recent
  if (authorizedEmails.length > 0 && (now - lastFetchTime) < CACHE_DURATION) {
    return authorizedEmails;
  }

  try {
    authorizedEmails = await getAdmins();
    lastFetchTime = now;

    console.log('Authorized emails loaded from Firestore:', authorizedEmails.length, 'emails');
    return authorizedEmails;
  } catch (error) {
    console.error('Error fetching authorized emails:', error);
    // Fallback to empty array on error
    return [];
  }
};

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error('Error signing in with Google:', error);
    throw error;
  }
};

export const signOutUser = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

export const isAuthorizedUser = async (user) => {
  if (!user || !user.email) return false;

  const admins = await fetchAuthorizedEmails();
  // admins is now an array of objects with {email, addedBy, addedAt}
  return admins.some(admin => admin.email === user.email.toLowerCase());
};

export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

export const getCurrentUser = () => {
  return auth.currentUser;
};